import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import CandlestickLoader from "@/components/common/CandlestickLoader";
import { useAuth } from "@/contexts/AuthContext";

const AUTH_CALLBACK_MESSAGES = [
  "Completing the Lorentzian handshake",
  "Locking in encrypted credentials",
  "Syncing your strategist profile",
  "Escorting you to mission control",
];

export function AuthCallback() {
  const { aiewToken, isLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // As soon as the AuthContext provides a token and is no longer loading, we can redirect.
    if (!isLoading && aiewToken) {
      console.log("✅ [AUTH-CALLBACK] Token found, redirecting to dashboard");
      navigate("/dashboard", { replace: true });
    } else if (!isLoading && !aiewToken) {
      console.error("❌ [AUTH-CALLBACK] No token found after OAuth callback!", {
        isLoading,
        hasToken: !!aiewToken,
        currentPath: window.location.pathname,
        searchParams: window.location.search
      });
    }
  }, [aiewToken, isLoading, navigate]);

  // You can also add a check here for the case where authentication fails.
  // For now, we show the global candlestick loader while auth resolves.

  return (
    <div className="flex min-h-screen w-screen items-center justify-center bg-background px-6">
      <CandlestickLoader
        isLoading
        context="AuthCallback"
        containerClassName="w-full min-h-[70vh]"
        messageClassName="text-slate-200"
        messages={AUTH_CALLBACK_MESSAGES}
      />
    </div>
  );
}
